module.exports = __webpack_public_path__ + "static/media/ico-video-level2.84fa394f.svg";